export default {
    GET_QUEUE_REQUEST: 'GET_QUEUE_REQUEST',
    GET_QUEUE_SUCCESS: 'GET_QUEUE_SUCCESS',
    GET_QUEUE_FAILURE: 'GET_QUEUE_FAILURE',

    GET_SILENT_QUEUE_REQUEST: 'GET_SILENT_QUEUE_REQUEST',
    GET_SILENT_QUEUE_SUCCESS: 'GET_SILENT_QUEUE_SUCCESS',
    GET_SILENT_QUEUE_FAILURE: 'GET_SILENT_QUEUE_FAILURE',

    RESET_QUEUE_STATE: 'RESET_QUEUE_STATE'
};
